<ion-item lines="none">
  <ion-label>{{label}}</ion-label>
  <ion-select [formControl]="$any(formControl)" [interface]="interface" [interfaceOptions]="interfaceOptions" mode="ios" *ngIf="!loadingAll && !loadingCurrent">
    <ion-select-option *ngFor="let project of projects" [value]="project.number">{{project.name}}</ion-select-option>
  </ion-select>
</ion-item>
